<div class="dashboard-wrapper">
  <mpro-dropdown
    title="Your Selection"
    [inputValue]="inputValue"
    (openDropdownAction)="onDropdownOpened()">
    <div class="user-dashboards-label" *ngIf="userDashboards.length && !addNew">Your dashboards</div>
    <mpro-dropdown-item class="inverse-hover" *ngFor="let d of userDashboards" [actions]="true" [leftText]="d.name || ''"
      (click)="onDashboardClicked(d.name || '')"
      (editClicked)="onEditClicked(d)"
      (deleteClicked)="onDeleteClicked(d)"
      [selected]="d.name === inputValue"></mpro-dropdown-item>
    <div class="system-dashboards-label">wdl dashboards</div>
    <mpro-dropdown-item *ngFor="let d of systemDashboards" [leftText]="d" (click)="onDashboardClicked(d)" [selected]="d === inputValue"></mpro-dropdown-item>
    <mpro-dashboard-dialog-box
      class="mpro-box"
      *ngIf="addNew"
      (save)="onSave($event)"
      (cancel)="setAddNew(false)"
      title="Create/Edit Custom Dashboard"
      [dashboardFilter]="inEditCustomDashboard"
  ></mpro-dashboard-dialog-box>
  </mpro-dropdown>

  <button class="mpro-btn mpro-btn-primary col-1 save-button" (click)="setAddNew(true)" stopClickPropagation>
    <fa-icon [icon]="faSave"></fa-icon>
  </button>
</div>
